import { customElement, property } from 'lit/decorators.js';
import {html, LitElement, nothing} from "lit";
import {choose} from 'lit/directives/choose.js';
import {style} from "@/components/annotation/annotation.styles";
import {classMap} from 'lit/directives/class-map.js';

/**
 * @slot default - Inhalt
 */
@customElement('sbk-annotation')
export class SbkAnnotation extends LitElement {

    static shadowRootOptions = { ...LitElement.shadowRootOptions, delegatesFocus: true };

    @property({type: String})
    variant: 'error' | 'plain' | 'info' = 'info' ;

    @property({type: Boolean})
    disabled = false;

    static get styles() {
        return style;
    }

    render() {
        const classes = {'annotation-disabled': this.disabled, 'annotation-error': this.variant === 'error'};
        return html`
            <div class="annotation ${classMap(classes)}">
                ${choose(this.variant, [
                    ['error', () => html`<sbk-icon size="20" symbol="warning"></sbk-icon>`],
                    ['plain', () => html`${nothing}`],
                ],
                () => html`<sbk-icon size="20" symbol="info"></sbk-icon>`)}
                <span class="annotation__text"><slot></slot></span>
            </div>
        `;
    }
}
